window.NostoPopup = {
  currentProductId: null,
  
  open: function(productId, buttonElement) {
    // Check if button has data attribute indicating default-only variant
    // If buttonElement is not provided, try to find it by product ID
    if (!buttonElement) {
      const button = document.querySelector(`.nosto-pdp-card__atc[data-product-id="${productId}"]`);
      if (button) buttonElement = button;
    }
    
    if (buttonElement && buttonElement.hasAttribute('data-has-only-default-variant')) {
      const variantId = buttonElement.getAttribute('data-variant-id');
      const variantAvailable = buttonElement.getAttribute('data-variant-available') === 'true';
      
      // If variant is available, add directly to cart
      if (variantAvailable && variantId) {
        this.addToCartDirectly(variantId, 1, buttonElement);
        return;
      }
      // If variant is not available, button should be disabled (handled by CSS)
      // This code path shouldn't be reached if button is properly disabled
      return;
    }
    
    const dataContainer = document.getElementById(`nosto-data-${productId}`);
    if (!dataContainer) {
      console.error('Nosto Popup: Data container not found for product', productId);
      return;
    }
    
    const jsonScript = dataContainer.querySelector('.nosto-product-json');
    if (!jsonScript) return;
    let product;
    try {
      product = JSON.parse(jsonScript.textContent);
    } catch (e) {
      console.error('Nosto Popup: Invalid JSON', e);
      return;
    }
    
    const pickerElement = dataContainer.querySelector('.nosto-variant-picker');
    if (!pickerElement) {
      console.error('Nosto Popup: Variant picker not found for product', productId);
      return;
    }
    const pickerHtml = pickerElement.cloneNode(true);
    
    const popupInputs = pickerHtml.querySelectorAll('input');
    popupInputs.forEach(input => {
        const oldId = input.id;
        const newId = oldId + '-popup';
        input.id = newId;
        const label = pickerHtml.querySelector(`label[for="${oldId}"]`);
        if (label) {
            label.setAttribute('for', newId);
        }
    });
    
    const popup = document.getElementById('nosto-variant-popup');
    const productImage = document.getElementById('nosto-popup-product-image');
    const productVendor = document.getElementById('nosto-popup-product-vendor');
    const productTitle = document.getElementById('nosto-popup-product-title');
    const productPrice = document.getElementById('nosto-popup-product-price');
    const productTitleLink = document.getElementById('nosto-popup-product-title');
    
    if (productImage && product.featured_image) {
      productImage.src = product.featured_image;
      productImage.alt = product.title;
    }
    if (productVendor) productVendor.textContent = product.vendor || '';
    if (productTitle) productTitle.textContent = product.title;
    if (productTitleLink) productTitleLink.href = product.url || '#';
    
    const firstVariant = product.variants && product.variants.length > 0 ? product.variants[0] : null;
    if (productPrice && firstVariant) {
      productPrice.textContent = this.formatMoney(firstVariant.price);
    }
    
    const variantsContainer = document.getElementById('nosto-popup-variants-container');
    variantsContainer.innerHTML = '';
    variantsContainer.appendChild(pickerHtml);
    document.getElementById('nosto-qty-input').value = 1;
    this.currentProductId = productId;
    
    const existingHandler = variantsContainer._nostoVariantHandler;
    if (existingHandler) {
      variantsContainer.removeEventListener('change', existingHandler);
    }
    
    const variantChangeHandler = (e) => {
      if (e.target.type === 'radio' && e.target.closest('.nosto-variant-picker')) {
        const changedWrapper = e.target.closest('.nosto-variant-wrapper');
        const changedWrapperIndex = changedWrapper ? parseInt(changedWrapper.getAttribute('data-option-index')) || 0 : 0;
        
        this.updateAvailabilityClasses(variantsContainer, e.target);
        this.autoSelectIfInvalid(variantsContainer, changedWrapperIndex + 1);
        this.onVariantChange();
      }
    };
    
    variantsContainer._nostoVariantHandler = variantChangeHandler;
    variantsContainer.addEventListener('change', variantChangeHandler);
    
    const initialChecked = variantsContainer.querySelector('.nosto-variant-fieldset input:checked');
    this.updateAvailabilityClasses(variantsContainer, initialChecked || null);
    this.onVariantChange();
    
    popup.classList.add('nosto-popup--visible');
    document.body.style.overflow = 'hidden';
  },
  
  updateAvailabilityClasses: function(container, lastSelectedOption) {
    const select = container.querySelector('select.nosto-variant-master-select');
    if (!select) return;
    
    const allVariants = Array.from(select.options);

    // Get all option groups sorted by their index (hierarchical order)
    const wrappers = Array.from(container.querySelectorAll('.nosto-variant-wrapper'));
    const sortedWrappers = wrappers.sort((a, b) => {
      const indexA = parseInt(a.getAttribute('data-option-index')) || 0;
      const indexB = parseInt(b.getAttribute('data-option-index')) || 0;
      return indexA - indexB;
    });

    const firstChecked = sortedWrappers[0]?.querySelector('.nosto-variant-fieldset input:checked');
    if (!firstChecked) return;
    
    const firstOptionValue = firstChecked.value;
    const selectedOptionOneVariants = allVariants.filter(opt => {
      const o1 = opt.getAttribute('data-option1') || '';
      return o1 === firstOptionValue;
    });

    sortedWrappers.forEach((wrapper, wrapperIndex) => {
      if (wrapperIndex === 0) return;
      if (lastSelectedOption && lastSelectedOption.closest('.nosto-variant-wrapper') === wrapper) {
        return;
      }

      const fieldset = wrapper.querySelector('.nosto-variant-fieldset');
      if (!fieldset) return;
      
      const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      const currentOptionName = `option${wrapperIndex + 1}`;
      
      // Get the previous option's selected value
      const previousWrapper = sortedWrappers[wrapperIndex - 1];
      const previousFieldset = previousWrapper?.querySelector('.nosto-variant-fieldset');
      const previousChecked = previousFieldset?.querySelector('input:checked');
      if (!previousChecked) return;
      
      const previousOptionValue = previousChecked.value;
      
      // Filter variants that match the previous option AND are available
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(variant => {
          const variantOptionValue = variant.getAttribute(`data-option${wrapperIndex}`) || '';
          const isAvailable = variant.getAttribute('data-available') === 'true';
          return variantOptionValue === previousOptionValue && isAvailable;
        })
        .map(variant => {
          // Get the value for the current option (option2, option3, option4)
          return variant.getAttribute(`data-${currentOptionName}`) || '';
        })
        .filter(val => val !== ''); // Remove empty values

      // Update each input's availability
      inputs.forEach(input => {
        const value = input.value;
        const inputId = input.getAttribute('id');
        const label = fieldset.querySelector(`label[for="${inputId}"]`);
        
        let variantValueExists = false;
        selectedOptionOneVariants.forEach(variant => {
          const o1 = variant.getAttribute('data-option1') || '';
          const o2 = variant.getAttribute('data-option2') || '';
          const o3 = variant.getAttribute('data-option3') || '';
          if (o1 === value || o2 === value || o3 === value) {
            variantValueExists = true;
          }
        });

        const isAvailable = availableOptionInputsValue.includes(value);
        
        if (isAvailable && variantValueExists) {
          if (label) label.classList.remove('is-unavailable');
          input.removeAttribute('disabled');
          input.classList.remove('is-unavailable');
        } else {
          if (label) label.classList.add('is-unavailable');
          input.setAttribute('disabled', 'disabled');
          input.classList.add('is-unavailable');
        }
      });
    });
  },
  
  autoSelectIfInvalid: function(container, changedWrapperIndex) {
    const wrappers = Array.from(container.querySelectorAll('.nosto-variant-wrapper'));
    const sortedWrappers = wrappers.sort((a, b) => {
      const indexA = parseInt(a.getAttribute('data-option-index')) || 0;
      const indexB = parseInt(b.getAttribute('data-option-index')) || 0;
      return indexA - indexB;
    });
    
    for (let i = changedWrapperIndex; i < sortedWrappers.length; i++) {
      const wrapper = sortedWrappers[i];
      const fieldset = wrapper.querySelector('.nosto-variant-fieldset');
      if (!fieldset) continue;
      
      const checkedInput = fieldset.querySelector('input:checked');
      
      if (checkedInput) {
        const isUnavailable = checkedInput.classList.contains('is-unavailable') || 
                              checkedInput.hasAttribute('disabled');
        
        if (isUnavailable) {
          const allInputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
          let foundAvailable = false;
          
          for (const input of allInputs) {
            const inputIsUnavailable = input.classList.contains('is-unavailable') || 
                                       input.hasAttribute('disabled');
            if (!inputIsUnavailable) {
              input.checked = true;
              foundAvailable = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
              break;
            }
          }
          
          if (!foundAvailable) {
            checkedInput.checked = false;
          }
        }
      } else {
        const allInputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
        for (const input of allInputs) {
          const inputIsUnavailable = input.classList.contains('is-unavailable') || 
                                     input.hasAttribute('disabled');
          if (!inputIsUnavailable) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      }
    }
  },
  
  close: function() {
    const popup = document.getElementById('nosto-variant-popup');
    popup.classList.remove('nosto-popup--visible');
    document.body.style.overflow = '';
    
    const variantsContainer = document.getElementById('nosto-popup-variants-container');
    if (variantsContainer && variantsContainer._nostoVariantHandler) {
      variantsContainer.removeEventListener('change', variantsContainer._nostoVariantHandler);
      variantsContainer._nostoVariantHandler = null;
    }
  },
  
  adjustQty: function(delta) {
    const input = document.getElementById('nosto-qty-input');
    if (!input) return;

    let val = parseInt(input.value, 10) || 1;
    val += delta;
    if (val < 1) val = 1;
    input.value = val;

    // Update price on button and in popup to reflect new quantity
    const addToCartBtn = document.getElementById('nosto-add-to-cart-btn');
    const btnPriceDisplay = addToCartBtn && addToCartBtn.querySelector('.nosto-btn-price');
    const mobileProductPrice = document.getElementById('nosto-popup-product-price');

    if (this.currentVariantPriceCents && btnPriceDisplay) {
      const totalCents = this.currentVariantPriceCents * val;
      const formattedTotal = this.formatMoney(totalCents);
      btnPriceDisplay.textContent = ` - ${formattedTotal}`;
      if (mobileProductPrice) {
        mobileProductPrice.textContent = formattedTotal;
      }
    }
  },
  
  toggleOptions: function(btn) {
    const fieldset = btn.closest('.nosto-variant-fieldset');
    const hiddenInputs = fieldset.querySelectorAll('[data-hidden-option="true"]');
    const isExpanded = btn.classList.contains('nosto-expanded');
    
    const showMoreCount = btn.querySelector('.nosto-show-more-count');
    const showLessText = btn.querySelector('.nosto-show-less-text');
    
    if (isExpanded) {
      // Collapse
      hiddenInputs.forEach(el => el.style.display = 'none');
      btn.classList.remove('nosto-expanded');
      
      if (showMoreCount) showMoreCount.style.display = 'inline';
      if (showLessText) showLessText.style.display = 'none';
      
    } else {
      // Expand
      hiddenInputs.forEach(el => el.style.display = 'block');
      btn.classList.add('nosto-expanded');
      
      if (showMoreCount) showMoreCount.style.display = 'none';
      if (showLessText) showLessText.style.display = 'inline';
    }
  },

  onVariantChange: function() {
    const container = document.getElementById('nosto-popup-variants-container');
    const options = {};
    
    // Gather selected options
    const checkedInputs = container.querySelectorAll('input:checked');
    checkedInputs.forEach(input => {
       const index = input.getAttribute('data-index');
       options[index] = input.value;
    });
    
    // Find matching variant
    const select = container.querySelector('select.nosto-variant-master-select');
    const selectOptions = Array.from(select.options);
    
    const matchedOption = selectOptions.find(opt => {
       const o1 = opt.getAttribute('data-option1');
       const o2 = opt.getAttribute('data-option2');
       const o3 = opt.getAttribute('data-option3');
       
       let match = true;
       if (o1 && options['option1'] !== o1) match = false;
       if (o2 && options['option2'] !== o2) match = false;
       if (o3 && options['option3'] !== o3) match = false;
       
       return match;
    });
    
    const addToCartBtn = document.getElementById('nosto-add-to-cart-btn');
    const btnPriceDisplay = addToCartBtn && addToCartBtn.querySelector('.nosto-btn-price');
    const btnText = addToCartBtn && addToCartBtn.querySelector('.nosto-btn-text');
    const qtyInput = document.getElementById('nosto-qty-input');
    const mobileProductPrice = document.getElementById('nosto-popup-product-price');
    
    if (matchedOption && addToCartBtn && btnText) {
       select.value = matchedOption.value;
       const price = parseInt(matchedOption.getAttribute('data-price'), 10) || 0; // cents for one unit
       const available = matchedOption.getAttribute('data-available') === 'true';

       // Store current variant base price in cents
       this.currentVariantPriceCents = price;

       const qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
       const totalCents = price * qty;
       const formattedTotal = this.formatMoney(totalCents);

       if (mobileProductPrice) {
         mobileProductPrice.textContent = formattedTotal;
       }
       
       if (btnPriceDisplay) {
         btnPriceDisplay.textContent = ` - ${formattedTotal}`;
       }
       
       if (available) {
         addToCartBtn.disabled = false;
         btnText.textContent = 'In den Warenkorb';
       } else {
         addToCartBtn.disabled = true;
         btnText.textContent = 'Ausverkauft';
       }
    } else {
       select.value = "";
       this.currentVariantPriceCents = 0;
       if (addToCartBtn) addToCartBtn.disabled = true;
       if (btnText) btnText.textContent = 'Nicht verfügbar';
       if (btnPriceDisplay) btnPriceDisplay.textContent = '';
       if (mobileProductPrice) {
         mobileProductPrice.textContent = '';
       }
    }
  },
  
  formatMoney: function(cents) {
    return (cents / 100).toLocaleString('de-DE', {style: 'currency', currency: 'EUR'});
  },
  
  addToCartDirectly: function(variantId, quantity, buttonElement) {
    if (buttonElement) {
      buttonElement.classList.add('nosto-pdp-card__atc--loading');
    }
    
    const formData = {
      'items': [{
        'id': variantId,
        'quantity': quantity || 1
      }]
    };
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(data => {
      if (buttonElement) {
        buttonElement.classList.remove('nosto-pdp-card__atc--loading');
      }

      // Trigger existing cart events used elsewhere in the theme
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:add'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      // Trigger ajaxProduct:added so the header cart feedback drawer shows
      try {
        if (data && Array.isArray(data.items) && data.items.length) {
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: { product: data.items[0], products: data.items }
            })
          );
        }
      } catch (e) {
        console.error('Nosto Popup: failed to dispatch ajaxProduct:added', e);
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      if (buttonElement) {
        buttonElement.classList.remove('nosto-pdp-card__atc--loading');
      }
      alert('Fehler beim Hinzufügen zum Warenkorb.');
    });
  },
  
  addToCart: function() {
     const container = document.getElementById('nosto-popup-variants-container');
     const select = container.querySelector('select.nosto-variant-master-select');
     const variantId = select.value;
     
     const qty = document.getElementById('nosto-qty-input').value;
     const btn = document.getElementById('nosto-add-to-cart-btn');
     
     if (!variantId) {
        alert("Bitte wählen Sie eine Variante aus.");
        return;
     }
     
     btn.disabled = true;
     const originalText = btn.querySelector('.nosto-btn-text').textContent;
     btn.querySelector('.nosto-btn-text').textContent = 'Wird hinzugefügt...';
     
     const formData = {
       'items': [{
         'id': variantId,
         'quantity': qty
       }]
     };
     
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(data => {
      this.close();

      // Trigger existing cart events used elsewhere in the theme
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:add'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      // Trigger ajaxProduct:added so the header cart feedback drawer shows
      try {
        if (data && Array.isArray(data.items) && data.items.length) {
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: { product: data.items[0], products: data.items }
            })
          );
        }
      } catch (e) {
        console.error('Nosto Popup: failed to dispatch ajaxProduct:added', e);
      }
    })
     .catch((error) => {
       console.error('Error:', error);
       alert('Fehler beim Hinzufügen zum Warenkorb.');
     })
     .finally(() => {
       btn.disabled = false;
       btn.querySelector('.nosto-btn-text').textContent = originalText;
     });
  }
};
